// extracted by mini-css-extract-plugin
export default {"footer":"HomepageFoother_footer__Ptv7c","text":"HomepageFoother_text__zQRx4"};